import { render, staticRenderFns } from "./FeedbackHistoryDialog.vue?vue&type=template&id=949e9186&scoped=true"
import script from "./FeedbackHistoryDialog.vue?vue&type=script&lang=js"
export * from "./FeedbackHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./FeedbackHistoryDialog.vue?vue&type=style&index=0&id=949e9186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949e9186",
  null
  
)

export default component.exports